enum ProductLine {
  AuctionCom = 'auctioncom',
  // Morpheus = 'morpheus', // TBD on this one - but leaving it here as a TODO:
  SmartSale = 'smartsale',
}

export default ProductLine
